import React from 'react';
import NoResults from '../../Shared/components/Search/NoResults';
import Result from './Result';
const sections = [
    {
        name: 'action',
        title: 'tx_zigsitepackage.search.arrangeImmediately',
        types: ['typo3_content'],
        contentTypes: ['action'],
    },
    {
        name: 'unit',
        title: 'tx_zigsitepackage.search.units',
        types: ['unit'],
    },
    {
        name: 'complex',
        title: 'tx_zigsitepackage.search.complexes',
        types: ['complex'],
    },
    {
        name: 'project',
        title: 'tx_zigsitepackage.search.projects',
        types: ['typo3_project'],
    },
    {
        name: 'faq',
        title: 'tx_zigsitepackage.search.faq',
        types: ['typo3_kb'],
    },
    {
        name: 'download',
        title: 'tx_zigsitepackage.search.downloads',
        types: ['typo3_download'],
    },
    {
        name: 'other',
        title: 'tx_zigsitepackage.search.other',
        types: ['typo3_content', 'typo3_news'],
        contentTypes: ['page'],
    },
];
const Results = ({ hits }) => {
    const sectionedHits = {};
    for (const section of sections) {
        let hitsForTypes = hits.filter((hit) => section.types.includes(hit._type));
        if (section.contentTypes) {
            hitsForTypes = hitsForTypes.filter((hit) => hit._type != 'typo3_content' || section.contentTypes.includes(hit._source.fields.contentType));
        }
        if (!hitsForTypes.length) {
            continue;
        }
        sectionedHits[section.name] = hitsForTypes;
    }
    if (Object.keys(sectionedHits).length === 0) {
        return React.createElement(NoResults, null);
    }
    return (React.createElement("div", { className: "zds-flex-col zds-gap-y-16" }, sections.map((section) => {
        if (!sectionedHits[section.name]) {
            return null;
        }
        return React.createElement(Result, { key: section.name, section: section, hits: sectionedHits[section.name] });
    })));
};
export default Results;
